import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Box, Menu, MenuItem as MuiMenuItem, IconButton, Divider } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import { styled } from '@material-ui/core/styles';
import { ModuleTypeEnum, PluginManager, getIcon, ProfileManager } from '@kailona/core';
import { withModal } from '../../context/ModalContext';
var DropdownIcon = styled(IconButton)({
  padding: 0,
  borderRadius: 0,
  paddingLeft: '5px',
  '&:hover, &:focus': {
    backgroundColor: 'transparent',
    borderColor: '#c8c8c8 !important'
  }
});
var MenuItem = styled(MuiMenuItem)({
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  '& > .menuItemIcon': {
    marginRight: '15px',
    width: '21px',
    height: '21px',
    cursor: 'pointer',
    '& > svg': {
      width: '21px',
      height: '21px'
    }
  },
  '& > .menuItemLabel': {
    cursor: 'pointer'
  }
});

var ProfileMenu = /*#__PURE__*/function (_Component) {
  _inherits(ProfileMenu, _Component);

  var _super = _createSuper(ProfileMenu);

  function ProfileMenu(props) {
    var _this;

    _classCallCheck(this, ProfileMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getMenuItems", function () {
      var menuItems = []; // Get menu modules from plugins

      PluginManager.plugins.forEach(function (plugin) {
        var path = plugin.path,
            modules = plugin.modules;
        var menuModule = modules[ModuleTypeEnum.MenuModule];

        if (!menuModule) {
          return;
        }

        menuItems.push(_objectSpread({
          path: path
        }, menuModule));
      }); // Sort by priority (high priority comes first)

      menuItems.sort(function (mi1, mi2) {
        return mi1.priority < mi2.priority ? 1 : -1;
      });
      return menuItems.map(function (menuItem, index) {
        var menuItemIcon = getIcon(menuItem.icon);
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: index,
          className: "menuItem",
          onClick: function onClick() {
            return _this.onMenuItemClick(menuItem.path);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "menuItemIcon"
        }, menuItemIcon), /*#__PURE__*/React.createElement("span", {
          className: "menuItemLabel"
        }, menuItem.name));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMenuItemClick", function (path) {
      _this.handleClose();

      if (path) {
        _this.props.history.push(path);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onImportDataMenuItemClick", function () {
      _this.handleClose();

      _this.props.toggleImportDataModal(true);
    });

    _defineProperty(_assertThisInitialized(_this), "onPatientProfileMenuItemClick", function () {
      _this.handleClose();

      var activePatientId = ProfileManager.activePatientId;
      var profile = ProfileManager.profiles.find(function (p) {
        return p.patientId === activePatientId;
      });

      _this.props.toggleProfileEditModal(true, {
        profile: profile,
        onUpdate: _this.props.refreshUsers
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.setState({
        anchorEl: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.setState({
        anchorEl: event.target
      });
    });

    _this.state = {
      anchorEl: null
    };
    return _this;
  }

  _createClass(ProfileMenu, [{
    key: "render",
    value: function render() {
      var menuItems = this.getMenuItems();
      var anchorEl = this.state.anchorEl;
      var open = Boolean(anchorEl);
      return /*#__PURE__*/React.createElement("div", {
        className: "profile-menu"
      }, /*#__PURE__*/React.createElement(DropdownIcon, {
        "aria-label": "more",
        "aria-controls": "long-menu",
        "aria-haspopup": "true",
        onClick: this.handleClick,
        disableRipple: true,
        size: "small"
      }, /*#__PURE__*/React.createElement(ArrowDropDown, null)), /*#__PURE__*/React.createElement(Menu, {
        id: "menu-items",
        anchorEl: anchorEl,
        keepMounted: true,
        open: open,
        onClose: this.handleClose,
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        style: {
          marginTop: '9px'
        }
      }, menuItems, /*#__PURE__*/React.createElement(Box, {
        m: 1
      }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(MenuItem, {
        className: "menuItem",
        onClick: this.onImportDataMenuItemClick
      }, /*#__PURE__*/React.createElement("span", {
        className: "menuItemIcon"
      }, getIcon('CloudUploadOutlined')), /*#__PURE__*/React.createElement("span", {
        className: "menuItemLabel"
      }, t('ehr', 'Import Data'))), /*#__PURE__*/React.createElement(MenuItem, {
        className: "menuItem",
        onClick: this.onPatientProfileMenuItemClick
      }, /*#__PURE__*/React.createElement("span", {
        className: "menuItemIcon"
      }, getIcon('PersonOutline')), /*#__PURE__*/React.createElement("span", {
        className: "menuItemLabel"
      }, t('ehr', 'Patient Profile')))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ProfileMenu;
}(Component);

var _default = withRouter(withModal(ProfileMenu));

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DropdownIcon, "DropdownIcon", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileMenu.js");
  reactHotLoader.register(MenuItem, "MenuItem", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileMenu.js");
  reactHotLoader.register(ProfileMenu, "ProfileMenu", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileMenu.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/components/ProfileHeader/ProfileMenu.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();